export function formatDurationClock(totalSeconds: number): string {
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;
	const paddedMinutes = String(minutes).padStart(2, "0");
	const paddedSeconds = String(seconds).padStart(2, "0");

	return hours > 0
		? `${hours}:${paddedMinutes}:${paddedSeconds}`
		: `${paddedMinutes}:${paddedSeconds}`;
}

/** Convert seconds to billing units (1 unit = 6 min = 0.1h), floored at 0.1. */
export function secondsToBillingUnits(seconds: number): number {
	return Math.max(0.1, Math.floor(seconds / 360) / 10);
}
